import { format, formatDistanceToNow } from 'date-fns';

export function formatDate(date: string | Date, pattern = 'MMM d, yyyy'): string {
  return format(new Date(date), pattern);
}

export function formatRelativeTime(date: string | Date): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
}

export function formatCurrency(amount: number | null | undefined, currency = 'USD'): string {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatNumber(num: number | null | undefined): string {
  if (num == null) return '—';
  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(1)}M`;
  }
  if (num >= 1_000) {
    return `${(num / 1_000).toFixed(1)}K`;
  }
  return num.toLocaleString('en-US');
}

/** Ad platforms report modeled, fractional conversions; always display a whole number. */
export function formatConversions(num: number | null | undefined): string {
  return Math.round(num ?? 0).toLocaleString('en-US');
}

export function formatPercent(value: number | null | undefined, decimals = 1): string {
  if (value == null) return '—';
  return `${value.toFixed(decimals)}%`;
}

export function formatChange(value: number): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value}`;
}

export function formatTimestamp(date: string | Date): string {
  return format(new Date(date), "MMM d, yyyy 'at' h:mm a");
}

export function formatScheduledCallTime(iso: string): string {
  const d = new Date(iso);
  const time = d.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit' });
  const date = d.toLocaleString('en-US', { month: 'short', day: 'numeric' });
  return `${time} on ${date}`;
}
